import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { Link } from "react-router-dom";

function AtmosPOD() {
  const raindrops = Array.from({ length: 200 });
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      <div className="inner-new-section-1 AtmosPOD-bg-1 ">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500">
            <h1 className="white-color" data-aos="fade-up">
              AtmosPOD
              <sup>™</sup>– Orbital Climate Sensing & Terrestrial Sequestration
            </h1>
            <p data-aos="zoom-in">
              Decode the atmosphere, monitor Earth’s pulse, and activate climate
              intelligence with a satellite-linked platform for emissions
              tracking, air quality analytics, and ecological restoration.
            </p>
          </div>
          <div className=" padding-bottom-2">
            <div className="text-left" data-aos="fade-down">
              <Link
                to="/company/contact#Book-Meeting"
                className="button-1 green-bg"
              >
                Explore Orbital Dashboard
              </Link>
              <Link to="/company/contact#Book-Meeting" className="button-1">
                Partner for Planetary Intelligence
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 AtmosPOD-bg-2">
        <div className="wrapper height-inherit">
          <div className="top-sec-1 text-right">
            <div className="our-vision-wrap float-right-1">
              <div className="d-d"></div>
            </div>
          </div>

          <div className="bottom-sec-1 padding-bottom-2 text-center">
            <h2 className="white-color w-100" data-aos="fade-down">
              Sense the Sky. Heal the Earth.
            </h2>
            <br />
            <p className="w-100" data-aos="fade-up">
              {" "}
              “It doesn’t just see the climate—it understands and enables action
              at the speed of data.”
            </p>
            <p className="w-100" data-aos="fade-up">
              AtmosPOD™ is not just another environmental monitor—it’s a
              planetary guardian.
            </p>
            <p data-aos="fade-up">
              By merging orbital satellite feeds with terrestrial IoT stations,
              machine learning, and real-time analytics, AtmosPOD™ becomes a
              digital nervous system for Earth’s climate health and restoration
              ecosystems.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-section-1 green-bg-2">
        <div className="wrapper">
          <h2 data-aos="zoom-in" className="text-center green-color">
            Space Meets Soil: Core Capabilities
          </h2>
          <div className="pledge-wrap hydro-ul">
            <div className="pledge-line"></div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img
                  src={assets.AtmosPOD_intelligence_1}
                  alt=""
                  data-aos="zoom-in"
                />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>1. Satellite-Integrated Atmospheric Intelligence</h4>
                <p>
                  <ul>
                    <li>
                      AI-enhanced satellite feeds for CO₂, CH₄, NOx, SO₂ mapping
                    </li>
                    <li>
                      Urban heat islands, wind-borne pollution, and ozone layer
                      health
                    </li>
                    <li>
                      Global to hyperlocal air quality index (AQI) modeling
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img
                  src={assets.AtmosPOD_intelligence_2}
                  alt=""
                  data-aos="zoom-in"
                />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>
                  2. Ground-Station Fusion for Real-Time Emissions Tracking
                </h4>
                <p>
                  <ul>
                    <li>
                      Co-located IoT pods for industrial, vehicular, and civic
                      emissions
                    </li>
                    <li>
                      Integration with smart cities, SEZs, and national
                      monitoring grids
                    </li>
                    <li>
                      Cross-verified insights using multi-spectral and LiDAR
                      data
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img
                  src={assets.AtmosPOD_intelligence_3}
                  alt=""
                  data-aos="zoom-in"
                />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>3. Soil & Forest Carbon Sequestration Analytics</h4>
                <p>
                  <ul>
                    <li>
                      Long-term monitoring of reforestation and land carbon
                      sinks
                    </li>
                    <li>MRV-ready soil carbon tracking via embedded sensors</li>
                    <li>
                      Integration with BioFORGE™ for biochar-enhanced
                      sequestration maps
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img
                  src={assets.AtmosPOD_intelligence_4}
                  alt=""
                  data-aos="zoom-in"
                />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>4. Smart Air Quality & Pollution Load Monitoring</h4>
                <p>
                  <ul>
                    <li>AQI forecasts with predictive anomaly detection</li>
                    <li>
                      Public health overlays for schools, hospitals & industrial
                      clusters
                    </li>
                    <li>
                      Citizen alert systems through AccelALERT™ integration
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img
                  src={assets.AtmosPOD_intelligence_5}
                  alt=""
                  data-aos="zoom-in"
                />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>5. Urban Ecology & Rewilding Intelligence</h4>
                <p>
                  <ul>
                    <li>Ecological baseline mapping of urban biodiversity</li>
                    <li>Rooftop green index + carbon sink simulation</li>
                    <li>Regeneration mapping with drone + satellite fusion</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 AtmosPOD-bg-3">
        <div className="wrapper height-inherit">
          <div className="AtmosPOD-two-col-main">
            <div className="AtmosPOD-two-col-1">
              {" "}
              <h2 className="green-color">Climate, Compliance & Carbon</h2>
            </div>
            <div className="AtmosPOD-two-col-2">
              <h4>Built to Power:</h4>
              <div className="building-list">
                <ul>
                  <li>Net Zero Audits</li>
                  <li>Air Quality Mandates & Public Health Impact Indices</li>
                  <li>
                    Urban Planning, Forest Health Monitoring, CSR & ESG
                    Portfolios
                  </li>
                  <li>
                    Carbon Credit Validation for Natural Sequestration Projects
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* <div className="bioforge-align-right ">
            <div className="bioforge-section-2-1">
              <h2 className="green-color">Climate, Compliance & Carbon</h2>
              <h4>Built to Power:</h4>
              <div className="building-list">
                <ul>
                  <li>Net Zero Audits</li>
                  <li>Air Quality Mandates & Public Health Impact Indices</li>
                  <li>
                    Urban Planning, Forest Health Monitoring, CSR & ESG
                    Portfolios
                  </li>
                  <li>
                    Carbon Credit Validation for Natural Sequestration Projects
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="inner-new-section-1 AtmosPOD-bg-6">
        <div className="wrapper">
          <h2 className="text-center green-color ">AtmosPOD Architecture</h2>
          <div className="mrv-three-col-main ">
            <div className="mrv-three-col-1">
              <img src={assets.AtmosPOD_Architecture_img1} alt="mrvimg1" />
              <b>Satellite Sources</b>
              <p className="black-color">
                Sentinel, MODIS, Landsat, GHGSat, and custom LEO networks
              </p>
            </div>
            <div className="mrv-three-col-1">
              <img src={assets.AtmosPOD_Architecture_img2} alt="mrvimg1" />
              <b>Ground Hardware</b>
              <p className="black-color">
                Atmospheric Pods (IoT-enabled), Solar-powered Edge Nodes
              </p>
            </div>
            <div className="mrv-three-col-1">
              <img src={assets.AtmosPOD_Architecture_img3} alt="mrvimg1" />
              <b>AI Stack</b>
              <p className="black-color">
                Anomaly detection, Predictive emissions forecasting, NDVI +
                thermal correlation
              </p>
            </div>
          </div>
          <p className="text-center black-color">
            <i>Data moves from orbit to insight in milliseconds.</i>
          </p>
        </div>
      </div>

      <div className="ecosystem-bg ">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Deployment Models</h2>
          </div>
          <img
            src={assets.AtmosPOD_Deployment_Models}
            alt="AtmosPOD_Deployment_Models"
            data-aos="zoom-in"
          />
        </div>
      </div>
      <div className="inner-new-section-1 AtmosPOD-bg-6 height-inherit-2">
        <div className="wrapper">
          <h2 className="text-center">Impact Metrics</h2>

          <div className="ethos-wrap">
            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.aim_1} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>Tons of CO₂e and PM₂.₅ tracked monthly</p>
              </div>
            </div>

            <div className="ethos-card ">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.aim_2} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>% reduction in air toxicity through rewilding programs</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.aim_3} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>Real-time AQI accuracy benchmarking vs ground stations</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.aim_4} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>Biodiversity impact scores for urban reforestation</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.aim_5} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>Verified soil carbon gains post-biochar deployment</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="our-philosophy-bg-1 AtmosPOD-bg-4">
        <div className="wrapper height-inherit">
          <div class="flagship-heading" data-aos="zoom-in">
            <h2 className="green-color">Carbon Markets & MRV-Ready</h2>
            <p>
              Integrated with Verra, Gold Standard, and SDG-aligned crediting
              protocols
            </p>
            <div className="line-3"></div>
            <p>
              Blockchain-ready traceability for air and soil-linked carbon
              assets
            </p>
            <div className="line-3"></div>
            <p>
              Geo-tagged, satellite-verified reporting for compliance bodies
            </p>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 AtmosPOD-bg-5">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 padding-bottom-2">
            <h2 className="white-color" data-aos="fade-down">
              Powered by Earth & Orbit Intelligence
            </h2>
            <p data-aos="fade-up">
              AtmosPOD™ is engineered by Accel1’s orbital analysts, AI
              developers, and climate architects — blending Earth observation
              science with policy-grade decision support tools.
            </p>
            <p data-aos="fade-up">
              “From a molecule in the air to a root in the soil, AtmosPOD sees
              it all.”
            </p>
          </div>
        </div>
      </div>
      <div className="about-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="green-color">
              Ready to Launch the Next Era of Climate Sensing?
            </h2>
            <p>
              Deploy AtmosPOD™ for continuous atmospheric understanding,
              health-informed action, and global sustainability transformation.
            </p>

            <Link
              to="/company/contact"
              className="button-1"
              onClick={scrollToTop}
            >
              Schedule a Satellite + Soil Briefing
            </Link>
            <Link
              to="/company/contact"
              className="button-1"
              onClick={scrollToTop}
            >
              Partner on Climate Sensing Grid
            </Link>
          </div>
        </div>
      </div>
      {/* <div className="section-1" style={sectionStyle}>
        <img src={assets.banner1} alt="" data-aos="fade-up" />
      </div> */}
    </div>
  );
}

export default AtmosPOD;
